"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSPOTokenFailedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "GetSPOTokenFailed";
const messageKey = "plugins.spfx.cannotGetSPOToken";
class GetSPOTokenFailedError extends teamsfx_api_1.SystemError {
    constructor() {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey),
        });
    }
}
exports.GetSPOTokenFailedError = GetSPOTokenFailedError;
//# sourceMappingURL=getSPOTokenFailedError.js.map